<template>
  <div>
    <div v-for="(item, index) in units" :key="index" class="item-unit">
      <el-input
        v-model="item.firstLevel"
        placeholder="请输入承办单位"
        class="first-level"
        @blur="(e) => check(e, index)"
        :disabled="noEdit"
      ></el-input>
      一
      <el-input
        v-model="item.twoLevel"
        :placeholder="noEdit ? '' : '请输入二级承办单位（选填）'"
        class="second-level"
        @blur="delivery"
        :disabled="noEdit"
      ></el-input>
      <i
        class="el-icon-circle-plus-outline i-adopt"
        @click="addUnit(index)"
        v-show="!noEdit"
      ></i>
      <i
        class="el-icon-remove-outline i-adopt"
        v-show="(index > 0 || units.length > 1) && !noEdit"
        @click="delUnit(index)"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initUnits: {
      type: Array,
      default: () => {
        return [{ firstLevel: "", twoLevel: "" }];
      },
    },
    noEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      units: [{ firstLevel: "", twoLevel: "" }],
    };
  },
  watch: {
    initUnits: {
      handler(newValue, oldValue) {
        // console.log('initUnits---new:', newValue);
        if (!newValue || newValue.length === 0) {
          this.units = [{ firstLevel: "", twoLevel: "" }];
        } else {
          this.units = newValue;
        }
      },
      deep: true
    }
  },
  mounted() {
    setTimeout(() => {
      // console.log("initUnits---", !!this.initUnits[0]);
      if (!!this.initUnits[0]) {
        this.units = this.initUnits;
      }
    }, 500);
  },
  methods: {
    addUnit(index) {
      this.units.splice(index + 1, 0, { firstLevel: "", twoLevel: "" });
    },
    delUnit(index) {
      this.units.splice(index, 1);
    },
    check(e, index) {
      let s = e.target.value;
      if (!s) {
        this.$message.warning("必须输入一级承办单位！");
      }
      this.$emit("getTakeUnit", this.units);
    },
    delivery() {
      this.$emit("getTakeUnit", this.units);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-unit {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
}
.first-level {
  width: 200px;
}
.second-level {
  width: 300px;
}
.i-adopt {
  cursor: pointer;
  vertical-align: -3px;
  font-size: 25px;
  margin-left: 15px;
}
</style>
